import { useState } from "react";
import { useTranslation } from "react-i18next";

import { AppLayout } from "@/components/AppLayout";
import { PermissionGate } from "@/components/PermissionGate";
import {
  InviteList,
  InviteMemberModal,
  MemberDirectory,
} from "@/modules/admin";

export default function AdminMembersPage() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  return (
    <>
      <AppLayout
        title={t("admin.members.pageTitle")}
        headerAction={
          <PermissionGate perm="org.member.invite">
            <button className="btn-primary" onClick={() => setOpen(true)}>
              {t("admin.members.inviteMember")}
            </button>
          </PermissionGate>
        }
      >
        <MemberDirectory />
        {/* Pending invitations (invitee emails/roles) + the Resend action are
            an inviter-only concern — hide the whole section from members who
            lack org.member.invite (e.g. operators), who'd otherwise see the
            list and a Resend button that 403s. */}
        <PermissionGate perm="org.member.invite">
          <InviteList />
        </PermissionGate>
      </AppLayout>
      {open && <InviteMemberModal onClose={() => setOpen(false)} />}
    </>
  );
}
